import { render, staticRenderFns } from "./BServices.vue?vue&type=template&id=054487ec&scoped=true&"
import script from "./BServices.vue?vue&type=script&lang=js&"
export * from "./BServices.vue?vue&type=script&lang=js&"
import style0 from "./BServices.vue?vue&type=style&index=0&id=054487ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054487ec",
  null
  
)

export default component.exports